import type {
  CreateMediaQueries,
  MediaQuery,
  GetCurrentBreakPoint,
  EmptyBreakpoint
} from './types';

export const EMPTY_BREAKPOINT: EmptyBreakpoint = {
  breakpoint: undefined,
  minWidth: undefined,
  maxWidth: undefined
};

export const createMediaQueries: CreateMediaQueries = breakpoints => {
  const sortedBreakpoints = Object.keys(breakpoints).sort(
    (a, b) => breakpoints[b] - breakpoints[a]
  );

  return sortedBreakpoints.map((breakpoint, index) => {
    let query = '';

    const minWidth = breakpoints[breakpoint] as (typeof breakpoints)[keyof typeof breakpoints];

    const nextBreakpoint = sortedBreakpoints[index - 1] as string | undefined;

    const maxWidth = nextBreakpoint ? breakpoints[nextBreakpoint] : null;

    if (minWidth >= 0) {
      query = `(min-width: ${minWidth}px)`;
    }

    if (maxWidth !== null) {
      if (query) {
        query += ' and ';
      }

      query += `(max-width: ${maxWidth - 1}px)`;
    }

    const mediaQuery: MediaQuery<typeof breakpoints> = {
      breakpoint,
      maxWidth: maxWidth ? maxWidth - 1 : null,
      minWidth,
      query
    };

    return mediaQuery;
  });
};

export const getCurrentBreakPoint: GetCurrentBreakPoint = (mediaQueries, defaultBreakpoint) => {
  for (const { query, ...breakpoint } of mediaQueries) {
    if (typeof window !== 'undefined' && !defaultBreakpoint) {
      const mediaQuery = window.matchMedia(query);

      if (mediaQuery.matches) {
        return breakpoint;
      }
    } else if (breakpoint.breakpoint === defaultBreakpoint) {
      return breakpoint;
    }
  }

  return EMPTY_BREAKPOINT;
};
